import styles from './WeeklyHighlight.module.css';
import { formatPrice } from '../utils/PriceUtil';
import { Link } from 'react-router-dom';
import { useHighlight } from '../hooks/useWeeklyHighlight';

export default function WeeklyHighlight () {

    const { highlight } = useHighlight();

    return highlight? <div className={styles.container}>
        <div>
            <div className={styles.polyFrame}>
                <div className={styles.polyClip}>
                    <img src={highlight.event.imageUrl} alt={highlight.title ?? highlight.event.title}/>
                </div>
            </div>
            <div className={styles.eventInfo}>
                <strong>{highlight.title ?? highlight.event.title}</strong> @ {highlight.event.locationName}
                <div className={styles.smallInfo}>{highlight.event.date}</div>
                <div className={styles.smallInfo}>{formatPrice(highlight?.event.price)}</div>
            </div>
        </div>
        <div>
            <div className={styles.twist2}></div>
            <h1>Notre <br/><span className={styles.yellowText}>coup de cœur</span></h1>
            <h2>cette semaine</h2>
            <Link to={"/details/" + highlight.event.id}><div className={styles.detailsBtn}>Plus de détails</div></Link>
        </div>
    </div> : <></>;

}